import { render, staticRenderFns } from "./chainBottom.vue?vue&type=template&id=25923428&scoped=true&"
import script from "./chainBottom.vue?vue&type=script&lang=js&"
export * from "./chainBottom.vue?vue&type=script&lang=js&"
import style0 from "./chainBottom.vue?vue&type=style&index=0&id=25923428&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25923428",
  null
  
)

export default component.exports